import { Dispatch } from '@reduxjs/toolkit';
import { setCountries } from '../actions';
import { AppState } from '../store';

export function getCountries(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Geography/countries`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const countries = await data.json();
      dispatch(setCountries(countries));
    } catch (error) {
      console.error(error);
    }
  };
}
